import { render, staticRenderFns } from "./AlertDialogue.vue?vue&type=template&id=08ff47a4&scoped=true"
import script from "./AlertDialogue.vue?vue&type=script&lang=js"
export * from "./AlertDialogue.vue?vue&type=script&lang=js"
import style0 from "./AlertDialogue.vue?vue&type=style&index=0&id=08ff47a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ff47a4",
  null
  
)

export default component.exports